import { render, staticRenderFns } from "./PartnersBalView.vue?vue&type=template&id=03f64622&"
import script from "./PartnersBalView.vue?vue&type=script&lang=js&"
export * from "./PartnersBalView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports